<template>
  <div id="app">
    <v-app>
      <nav-bar :isCheckout="isCheckout"></nav-bar>
      <div class="top-bar primary"></div>
      <v-main>
        <router-view></router-view>
      </v-main>
      <app-footer :isCheckout="isCheckout" />
      <snackbar />
      <cookie primary-color="#6d9934" :lang="$i18n.locale" />
    </v-app>
  </div>
</template>

<script>
import Cookie from "./components/Cookie2022.vue";
import NavBar from "./components/System/NavBar.vue";
import Footer from "./components/Footer/Footer";
import Snackbar from "./components/System/Snackbar";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "app",
  metaInfo: {
    title: "Koupaliště a kemp Lodín",
    titleTemplate: "%s | Koupaliště a kemp Lodín",
  },
  components: {
    NavBar,
    AppFooter: Footer,
    Snackbar,
    Cookie,
  },
  computed: {
    ...mapGetters(["allCategories"]),
  },
  data() {
    return {
      isCheckout: false,
    };
  },
  mounted() {
    this.isCheckout = this.$router.currentRoute.name === "Checkout";
    if (!this.allCategories.length) {
      this.retrieveCategories(this.$i18n.locale);
    }
  },
  watch: {
    "$route.name": function (val) {
      this.isCheckout = val === "Checkout";
    },
    "$i18n.locale": function (val) {
      this.retrieveCategories(val);
    },
  },
  methods: {
    ...mapActions(["retrieveCategories"]),
  },
};
</script>

<style lang="scss">
@media (min-width: 1904px) {
  .container {
    max-width: 1185px;
    &.container--fluid {
      max-width: 100%;
    }
  }
}

.top-bar {
  height: 2px;
}

.v-application {
  font-family: "Inter", sans-serif !important;
  .body-2 {
    font-family: "Inter", sans-serif !important;
  }
}
</style>
